import debounce from 'lodash/debounce'

function biggerThanBreakpoint (breakpoint) {
  return window.innerWidth > breakpoint
}

function toggleFooterAccordion (event) {
  if (biggerThanBreakpoint(450)) {
    return
  }

  const trigger = event.currentTarget
  const parent = trigger.parentElement
  parent.classList.toggle('open')
}

function handleFooterResize (footerMenuContainers) {
  return debounce(() => {
    if (biggerThanBreakpoint(450)) {
      footerMenuContainers.forEach(el => el.classList.remove('open'))
    }
  }, 500)
}

export default function FooterAccordions () {
  const footerMenuTitles = document.querySelectorAll('.title')
  const footerMenuContainers = document.querySelectorAll('.menu-container')

  if (footerMenuTitles.length > 0) {
    footerMenuTitles.forEach(el =>
      el.addEventListener('click', event => toggleFooterAccordion(event))
    )

    window.addEventListener('resize', debounce(() => {
      if (biggerThanBreakpoint(450)) {
        footerMenuContainers.forEach(el => el.classList.remove('open'))
      }
    }, 500))
  }
}
